import React, {useEffect, useState } from "react";
import {
    TableRow, TableHead, TableCell, TableBody, Box, Checkbox, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Switch, Typography,
    Tab, Tabs, Paper
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { TableStyle, Flex } from '../Common/CommonStyle';
import { inject, observer } from "mobx-react";
import FileAddDialog from './FileAddDialog';
import _ from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import StorageIcon from '@mui/icons-material/Storage';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import CommonComfirmDialog from "../Common/CommonComfirmDialog";
import RagTestDialog from "./RagTestDialog";
import SmsIcon from '@mui/icons-material/Sms';
dayjs.extend(timezone);
dayjs.extend(utc);

const Root = styled(Box)(() => ({
    width: '100%',
}));

const TableWrap = styled(Box)(() => ({
    overflowY: 'hidden',
    overflowX: 'auto',
    '& table.MuiTable-root': {
        minWidth: 1024,
    },
}));

const CustomSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 37,
    height: 20,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(17px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#fdd751',
                border: 'none',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 16,
        height: 16,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 16,
        backgroundColor: '#E0E0E0',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
}));

function RagBookManageTableComponents(props) {
    const {dashboardStore} = props;
    const {checkedIdList, setCheckedIdList} = props;
    const paperRef = React.useRef(null);

    const [editId, setEditId] = useState('');
    const [editValue, setEditValue] = useState('');
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [newFile, setNewFile] = useState(null);
    const [newFileName, setNewFileName] = useState('');
    const [newFileDescription, setNewFileDescription] = useState('');
    const [isPictureBook, setIsPictureBook] = useState(false);
    const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
    const [duplicateMsg, setDuplicateMsg] = useState('');
    const [openExceededDialog, setOpenExceededDialog] = useState(false);
    const [openInvalidFileNameDialog, setOpenInvalidFileNameDialog] = useState(false);
    const [openTestDialog, setOpenTestDialog] = useState(false);
    const [isTestEnabled, setIsTestEnabled] = useState(false);
    const [sendMessage, setSendMessage] = useState('');
    const [openDetailDialog, setOpenDetailDialog] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [editingData, setEditingData] = useState({ id: '', page: '', content: '' });
    const [newPageNumber, setNewPageNumber] = useState('');
    const [newContent, setNewContent] = useState('');

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedIdList, editId, editValue]);

    const ragBookList = dashboardStore.ragBookList;

    const getAllCheckStatus = () => {
        return checkedIdList.length === dashboardStore.ragBookList.length;
    }

    const getDate = (createdDatetime) => {
        return dayjs(createdDatetime).tz('UTC', true).tz('Asia/Seoul').format('YYYY.MM.DD HH:mm:ss');
    }

    const handleSelectAllChange = () => {
        let newCheckedIdList = [];

        if (getAllCheckStatus()) {
            newCheckedIdList = [];
        } else {
            for (const ragBook of ragBookList) {
                newCheckedIdList.push(ragBook.id);
            }
        }
        setCheckedIdList(newCheckedIdList);
    };

    const handleSelectChange = (targetId) => {
        let newCheckedIdList = _.cloneDeep(checkedIdList);

        if (checkedIdList.includes(targetId)) {
            newCheckedIdList = newCheckedIdList.filter(id => id !== targetId);
        } else {
            newCheckedIdList.push(targetId);
        }

        setCheckedIdList(newCheckedIdList);
    };

    const handleClickDelete = () => {
        if (checkedIdList.length > 0) {
            dashboardStore.removeRagBook(checkedIdList, handleDeleteCallback);
        }
    };

    const handleDeleteCallback = () => {
        setCheckedIdList([]);
        dashboardStore.getRagBookList();
    }

    const handleOpenAddDialog = () => {
        setOpenAddDialog(true);
    }
    const handleCloseAddDialog = () => {
        setOpenAddDialog(false);
        setNewFile(null);
        setNewFileName('');
        setNewFileDescription('');
        setIsPictureBook(false);
    }

    const handleFileInputChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setNewFile(file);
            setNewFileName(file.name);
        }
    };

    const handleAddNewFile = () => {
        if (newFile) {
            dashboardStore.addRagBook(newFile, newFileDescription, isPictureBook, () => dashboardStore.getRagBookList(), (msg) => handleDuplicateFile(msg), () => handleExceededFile(), () => handleInvalidFileName());
            handleCloseAddDialog();
        }
    };

    const handleDuplicateFile = (msg) => {
        setDuplicateMsg(msg);
        setOpenDuplicateDialog(true);
    }

    const handleExceededFile = () => {
        setOpenExceededDialog(true);
    }

    const handleInvalidFileName = () => {
        setOpenInvalidFileNameDialog(true);
    }

    const handleClickEdit = (id, value) => {
        setEditId(id);
        setEditValue(value)
    };

    const handleChangeEditValue = (event) => {
        setEditValue(event.target.value);
    };

    const handleClickSave = () => {
        dashboardStore.updateRagBook(editId, editValue, () => dashboardStore.getRagBookList());

        setEditId('');
        setEditValue('');
    };

    const handleClickCancel = () => {
        setEditId('');
        setEditValue('');
    };

    const handleCloseDuplicateDialog = () => {
        setOpenDuplicateDialog(false);
        setDuplicateMsg('');
    }

    const handleCloseExceededDialog = () => {
        setOpenExceededDialog(false);
    }

    const handleCloseInvalidFileNameDialog = () => {
        setOpenInvalidFileNameDialog(false);
    }

    const handleClickDown = (ragBookId) => {
        dashboardStore.downloadRagBook(ragBookId);
    }

    const handleClickTest = (ragBook) => {
        dashboardStore.setTestRagBook(ragBook);
        handleOpenTestDialog();
    }

    const handleOpenTestDialog = () => {
        setOpenTestDialog(true);
    };

    const handleCloseTestDialog = () => {
        setOpenTestDialog(false);
        setIsTestEnabled(false);
    };

    const handleStartTest = () => {
        setIsTestEnabled(true);
        setSendMessage('');
        dashboardStore.getTestRagBook();
    }

    const handleClearTest = () => {
        dashboardStore.setTestRagBookDialogList([]);
        handleStartTest();
    }

    const handleOpenDetailDialog = (ragBook) => {
        dashboardStore.setEditRagBook(ragBook)
        dashboardStore.getRagData(() => setOpenDetailDialog(true));
    };

    const handleCloseDetailDialog = () => {
        setOpenDetailDialog(false);
        setSelectedTab(0);
        setNewPageNumber('');
        setNewContent('');
        dashboardStore.setEditRagBook({});
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setNewPageNumber('');
        setNewContent('');
        if (paperRef.current) {
            paperRef.current.scrollTop = 0;
        }
    };

    const getTypeString = () => {
        switch(selectedTab) {
            case 0:
                return "textSplit";
            case 1:
                return "gptSplit";
            case 2:
                return "image";
            default:
                return "textSplit";
        }
    }

    const getCurrentTabData = () => {
        if (dashboardStore.editRagData) {
            switch(selectedTab) {
                case 0:
                    return dashboardStore.editRagData.splitTextList;
                case 1:
                    return dashboardStore.editRagData.aiSplitTextList;
                case 2:
                    return dashboardStore.editRagData.imageTextList;
                default:
                    return [];
            }
        } else {
            return [];
        }
    };

    const handleDeleteItem = (id) => {
        dashboardStore.removeRagData(id);
    };

    const handleEditItem = (index) => {
        setEditingIndex(index);
        const currentData = getCurrentTabData()[index];
        setEditingData({
            id: currentData.id,
            page: currentData.page,
            content: currentData.content
        });
    };

    const handleSaveItem = (index) => {
        dashboardStore.updateRagData(editingData.id, getTypeString(), editingData.page, editingData.content);

        setEditingIndex(-1);
        setEditingData({ id: '', page: '', content: '' });
    };

    const handleCancelEdit = () => {
        setEditingIndex(-1);
        setEditingData({ id: '', page: '', content: '' });
    };

    const handleEditDataChange = (field, value) => {
        setEditingData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleAddItem = () => {
        if (!newPageNumber || !newContent) return;

        dashboardStore.addRagData(getTypeString(), newPageNumber, newContent);

        setNewPageNumber('');
        setNewContent('');
    };

    const modalContent = (
        <>
            <TextField
                margin='dense'
                id='fileName'
                label='업로드 파일명'
                type='text'
                fullWidth
                variant='standard'
                value={newFileName}
                onChange={(e) => setNewFileName(e.target.value)}
                disabled
            />
            <TextField
                margin='dense'
                id='fileDescription'
                label='파일 설명'
                type='text'
                fullWidth
                variant='standard'
                value={newFileDescription}
                onChange={(e) => setNewFileDescription(e.target.value)}
            />
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CustomSwitch
                        checked={isPictureBook}
                        onChange={() => setIsPictureBook(!isPictureBook)}
                    />
                    <Typography sx={{ ml: 1 }}>그림 도서</Typography>
                </Box>
            </Box>
        </>
    );

    return (
        <Root>
            <Flex sx={{ justifyContent: 'flex-end', marginBottom: '0.5rem' }}>
                <Button
                    onClick={handleOpenAddDialog}
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    sx={{ width: '100px' }}
                >
                    추가
                </Button>
                <Button onClick={handleClickDelete} variant="outlined" color="error" sx={{ ml: 1 }}>
                    삭제
                </Button>
            </Flex>
            <TableWrap>
                <TableStyle>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ width: '5%' }}>
                                <Checkbox
                                    checked={getAllCheckStatus()}
                                    onChange={handleSelectAllChange}
                                />
                            </TableCell>
                            <TableCell align="center" sx={{ width: '20%' }}>파일명</TableCell>
                            <TableCell align="center">설명</TableCell>
                            <TableCell align="center" sx={{ width: '15%' }}>추가 날짜</TableCell>
                            <TableCell align="center" sx={{ width: '5%' }}>S</TableCell>
                            <TableCell align="center" sx={{ width: '5%' }}>O</TableCell>
                            <TableCell align="center" sx={{ width: '5%' }}>B</TableCell>
                            <TableCell align="center" sx={{ width: '5%' }}>그림 도서</TableCell>
                            <TableCell align="center" sx={{ width: '10%' }}>파일 다운로드</TableCell>
                            <TableCell align="center" sx={{ width: '10%' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ragBookList.map((row, index) => (
                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="center">
                                    <Checkbox
                                        checked={checkedIdList.includes(row.id)}
                                        onChange={() => handleSelectChange(row.id)}
                                    />
                                </TableCell>
                                <TableCell>{row.fileName}</TableCell>
                                <TableCell sx={{position:'relative'}}>
                                    {editId === row.id ? (
                                        <>
                                            <TextField
                                                value={editValue}
                                                onChange={handleChangeEditValue}
                                                // onBlur={() => handleClickSave()}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter') {
                                                        handleClickSave();
                                                    } else if (event.key === 'Escape') {
                                                        handleClickCancel();
                                                    }
                                                }}
                                                sx={{width:'85%'}}
                                            />
                                            <IconButton 
                                                aria-label="save"
                                                onClick={() => handleClickSave()}
                                            >
                                                <SaveIcon />
                                            </IconButton>
                                            <IconButton 
                                                aria-label="cancel"
                                                onClick={handleClickCancel}
                                            >
                                                <CancelIcon />
                                            </IconButton>
                                        </>
                                    ) : (
                                        <>
                                            <span style={{
                                                overflow: 'hidden',
                                                width: '90%',
                                                display: 'inline-block',
                                                textOverflow: 'ellipsis',
                                                textWrap: 'nowrap',
                                                textAlign: 'center'
                                            }}
                                            >{row.description}</span>
                                            <IconButton
                                                aria-label="edit"
                                                onClick={() => handleClickEdit(row.id, row.description)}
                                                sx={{position:'absolute', right: '16px', top:'50%', transform:'translateY(-50%)'}}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                        </>
                                    )}
                                </TableCell>
                                <TableCell align="center">{getDate(row.createdDatetime)}</TableCell>
                                <TableCell align="center">{row.section}</TableCell>
                                <TableCell align="center">{row.owner}</TableCell>
                                <TableCell align="center">{row.book}</TableCell>
                                <TableCell align="center">{row.pictureBook ? 'Y' : 'N'}</TableCell>
                                <TableCell align="center">
                                    <Button
                                        variant='outlined'
                                        color="gray"
                                        sx={{
                                            borderColor: 'gray',
                                            color: 'gray.dark',
                                            '&:hover': {
                                                backgroundColor: 'gray.light',
                                                borderColor: 'gray.dark'
                                            }
                                        }}
                                        onClick={() => handleClickDown(row.id)}
                                    >다운로드
                                    </Button>
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton onClick={() => handleClickTest(row)}>
                                        <SmsIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleOpenDetailDialog(row)}>
                                        <StorageIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TableStyle>
            </TableWrap>

            <FileAddDialog
                open={openAddDialog}
                onClose={handleCloseAddDialog}
                title="RAG 도서 업로드"
                contentText="업로드할 파일을 선택하고 파일명 및 설명을 입력하세요."
                content={modalContent}
                fileInputProps={{accept: '.pdf'}}
                onFileChange={handleFileInputChange}
                onAdd={handleAddNewFile}
                onCancel={handleCloseAddDialog}
            />

            <CommonComfirmDialog
                open={openDuplicateDialog}
                title = {'업로드 실패'}
                contents={<React.Fragment>중복되는 도서가 이미 존재합니다. <br/>({duplicateMsg})</React.Fragment>}
                buttonText={'확인'}
                onClick={handleCloseDuplicateDialog}
            />

            <CommonComfirmDialog
                open={openExceededDialog}
                title = {'업로드 실패'}
                contents={<React.Fragment>더 이상 생성 할 수 없습니다.</React.Fragment>}
                buttonText={'확인'}
                onClick={handleCloseExceededDialog}
            />

            <CommonComfirmDialog
                open={openInvalidFileNameDialog}
                title = {'업로드 실패'}
                contents={<React.Fragment>파일명 형식이 잘못되었습니다. <br/>Section(숫자)_Owner(숫자)_Book(숫자)_파일명 형식을 따라야 합니다.</React.Fragment>}
                buttonText={'확인'}
                onClick={handleCloseInvalidFileNameDialog}
            />

            <Dialog 
                open={openTestDialog} 
                onClose={handleCloseTestDialog}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: '800px',
                        maxHeight: '80vh',
                        margin: '16px',
                        overflowX: 'hidden'
                    }
                }}
            >
                <DialogTitle sx={{
                    width: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    pr: '48px',
                    boxSizing: 'border-box'
                }}>
                    [테스트] {dashboardStore.testRagBook.fileName}
                </DialogTitle>
                <DialogContent sx={{ 
                    padding: '24px !important',
                    boxSizing: 'border-box',
                    width: '100%',
                    height: 'calc(80vh - 130px)',  // Dialog 높이에서 Title과 Actions 높이를 뺀 값
                    overflow: 'hidden'
                }}>
                    <Box sx={{ 
                        width: '100%',
                        height: '100%',
                        boxSizing: 'border-box',
                        overflow: 'hidden'
                    }}>
                        <RagTestDialog isTestEnabled={isTestEnabled} sendMessage={sendMessage} setSendMessage={setSendMessage} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    {isTestEnabled ?
                        <Button disabled={dashboardStore.testRagBookPrompt.trim() === ''} style={dashboardStore.testRagBookPrompt.trim() === '' ? {backgroundColor: '#D3D3D3', color: '#FFF'} : {backgroundColor: '#F9CB28', color: '#49454F'}} onClick={handleClearTest}>초기화</Button>
                        :
                        <Button disabled={dashboardStore.testRagBookPrompt.trim() === ''} style={dashboardStore.testRagBookPrompt.trim() === '' ? {backgroundColor: '#D3D3D3', color: '#FFF'} : {backgroundColor: '#F9CB28', color: '#49454F'}} onClick={handleStartTest}>대화 시작</Button>
                    }
                    <Button style={{backgroundColor: '#F9CB28', color: '#49454F'}} onClick={handleCloseTestDialog}>닫기</Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                open={openDetailDialog} 
                onClose={handleCloseDetailDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    [RAG 데이터 수정] {dashboardStore.editRagBook.fileName}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                        <Tabs value={selectedTab} onChange={handleTabChange}>
                            <Tab label="문장 나누기" />
                            <Tab label="AI 나누기" />
                            <Tab label="이미지" />
                        </Tabs>
                    </Box>
                    
                    {/* 데이터 추가 영역 */}
                    <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                        <TextField
                            size="small"
                            type="number"
                            value={newPageNumber}
                            onChange={(e) => setNewPageNumber(e.target.value)}
                            placeholder="페이지 번호"
                            sx={{ width: '150px' }}
                        />
                        <TextField
                            fullWidth
                            size="small"
                            value={newContent}
                            onChange={(e) => setNewContent(e.target.value)}
                            placeholder="내용"
                        />
                        <Button
                            variant="contained"
                            onClick={handleAddItem}
                            disabled={!newPageNumber || !newContent}
                        >
                            추가
                        </Button>
                    </Box>

                    {/* 데이터 목록 */}
                    <Paper ref={paperRef} sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {getCurrentTabData().map((item, index) => (
                            <Box key={index} sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #eee' }}>
                                {editingIndex === index ? (
                                    <>
                                        <TextField
                                            size="small"
                                            value={editingData.page}
                                            onChange={(e) => handleEditDataChange('page', e.target.value)}
                                            sx={{ width: '50px' }}
                                        />
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={editingData.content}
                                            onChange={(e) => handleEditDataChange('content', e.target.value)}
                                        />
                                        <IconButton color="primary" onClick={() => handleSaveItem(index)}>
                                            <SaveIcon />
                                        </IconButton>
                                        <IconButton onClick={handleCancelEdit}>
                                            <CancelIcon />
                                        </IconButton>
                                    </>
                                ) : (
                                    <>
                                        <Typography sx={{ width: '50px', px: 1 }}>{item.page}</Typography>
                                        <Typography sx={{ flex: 1, px: 1 }}>{item.content}</Typography>
                                        <IconButton onClick={() => handleEditItem(index)}>
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton onClick={() => handleDeleteItem(item.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </>
                                )}
                            </Box>
                        ))}
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button style={{color: 'black'}} onClick={handleCloseDetailDialog}>닫기</Button>
                </DialogActions>
            </Dialog>
        </Root>
    );
}

export default inject('dashboardStore')(observer(RagBookManageTableComponents));
